module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "overlay": false
    },
    model: {
      value: (_vm.controls.showDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDialog", $$v)
      },
      expression: "controls.showDialog"
    }
  }, [_c('v-btn', {
    staticClass: "site-reports-actions__action site-reports-actions__action--no-margin btn btn-nww",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n      Edit\n      "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.targetCollectionSite) ? _c('v-card', [_c('div', {
    staticClass: "page-content-header"
  }, [_c('div', {
    staticClass: "page-content-header__text"
  }, [_vm._v("\n          Edit Collection Site\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-body"
  }, [_c('form', {
    staticClass: "add-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Station Name",
      "required": ""
    },
    model: {
      value: (_vm.targetCollectionSite.stationName),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "stationName", $$v)
      },
      expression: "targetCollectionSite.stationName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Logbook Abbreviation",
      "required": ""
    },
    model: {
      value: (_vm.targetCollectionSite.logbookAbbv),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "logbookAbbv", $$v)
      },
      expression: "targetCollectionSite.logbookAbbv"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.labSet,
      "item-text": ".value",
      "item-value": ".value",
      "label": "Lab",
      "required": "",
      "bottom": ""
    },
    model: {
      value: (_vm.targetCollectionSite.lab),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "lab", $$v)
      },
      expression: "targetCollectionSite.lab"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Latitude (eg. 34.004401)",
      "required": ""
    },
    model: {
      value: (_vm.targetCollectionSite.latitude),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "latitude", $$v)
      },
      expression: "targetCollectionSite.latitude"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Longitude (eg. -84.350555)",
      "required": ""
    },
    model: {
      value: (_vm.targetCollectionSite.longitude),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "longitude", $$v)
      },
      expression: "targetCollectionSite.longitude"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.hucSet,
      "label": "Subwatershed (HUC 12) Name",
      "autocomplete": "",
      "bottom": ""
    },
    model: {
      value: (_vm.targetCollectionSite.hucName),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "hucName", $$v)
      },
      expression: "targetCollectionSite.hucName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Adopt-A-Stream Name"
    },
    model: {
      value: (_vm.targetCollectionSite.adoptAStreamName),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "adoptAStreamName", $$v)
      },
      expression: "targetCollectionSite.adoptAStreamName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Adopt-A-Stream 'S' ID (eg. S-4475)",
      "rules": [function (v) { return !!v || 'Enter the 4 numbers after S- only (Leave blank if no ID)'; }]
    },
    model: {
      value: (_vm.targetCollectionSite.aasNumber),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "aasNumber", $$v)
      },
      expression: "targetCollectionSite.aasNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "STORET Name"
    },
    model: {
      value: (_vm.targetCollectionSite.storetName),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "storetName", $$v)
      },
      expression: "targetCollectionSite.storetName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "STORET Location ID (eg. NWW24)"
    },
    model: {
      value: (_vm.targetCollectionSite.storetId),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "storetId", $$v)
      },
      expression: "targetCollectionSite.storetId"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.partnerSet,
      "item-text": ".value",
      "item-value": ".value",
      "label": "Collection Partner",
      "bottom": ""
    },
    model: {
      value: (_vm.targetCollectionSite.collectionPartner),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "collectionPartner", $$v)
      },
      expression: "targetCollectionSite.collectionPartner"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": ("" + (_vm.targetCollectionSite.isPrivate ? 'Check this box to hide from map (make private)' : 'Check this box to hide from map (make private)')),
      "success": ""
    },
    model: {
      value: (_vm.targetCollectionSite.isPrivate),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "isPrivate", $$v)
      },
      expression: "targetCollectionSite.isPrivate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('v-btn', {
    staticClass: "btn-nww",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save Site")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn",
    attrs: {
      "flat": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "error": true
    },
    model: {
      value: (_vm.snackbar.errorVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "errorVisible", $$v)
      },
      expression: "snackbar.errorVisible"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbar.errorMessage) + "\n        "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.errorVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6de4258"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/EditCollectionSite.vue
// module id = 450
// module chunks = 1